var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('headbar',{staticClass:"header"}),_vm._l((_vm.pages),function(page,index){return _c(page.com,{key:index,tag:"component"})}),_c('footbar',{staticClass:"footbar"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }